export default {
    permissions: []
  }
  